




import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { getParameterByName } from './util';

@Component({})
export default class App extends Vue {

    getParameterByName = getParameterByName;

    created(){
        // SafeMode
        const safeMode = this.getParameterByName('safe');
        const gotsafe = safeMode ? this.$store.commit('activateSafeMode') : this.$store.commit('deactivateSafeMode');
    }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue